import { Palette } from '@woundtech/ui-colors';

export const getLegalEntitiesStates = (
  entities: fhir.Organization[] | undefined = []
) => {
  return entities
    ?.map((edge) => edge?.address?.[0]?.state)
    .filter((item) => !!item)
    .filter((value, index, self) => self.indexOf(value) === index)
    .sort();
};

export const getStatusColor = (status) => {
  return status ? Palette.Teal.Main : Palette.Orange.Main;
};

export const getStatusText = (status) => {
  return status ? 'Active' : 'Inactive';
};
